import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BuyAssistancePackageComponent } from 'src/app/components/buy-assistance-package/buy-assistance-package.component';
import { BookingAssistancePackageComponent } from 'src/app/components/modal/booking-assistance-package/booking-assistance-package.component';
import { ConfirmDesignTermsComponent } from 'src/app/components/modal/confirm-design-terms/confirm-design-terms.component';
import { ArticleService } from 'src/app/service/article.service';

@Component({
  selector: 'app-assistance-package',
  templateUrl: './assistance-package.component.html',
  styleUrls: ['./assistance-package.component.scss']
})
export class AssistancePackageComponent implements OnInit {

  constructor(
    public matDialog : MatDialog,
    private fb: FormBuilder,
    private articleSrv: ArticleService
  ) { }

  selectedAP = this.fb.group({
    attributeId: new FormControl('', Validators.required),
    tier: new FormControl('', Validators.required),
    price: new FormControl('', Validators.required)
  }) 
  @Input() orderArticle: any;
  @Output() event = new EventEmitter<any>();
  articleAttributeList: any;
  article: any;
  tiers: any = [];
  readMore: boolean = false;

  changeId(id){
    this.selectedTier(id);
    this.selectedAP.value.attributeId = id;
  }

  selectedTier(id){
    let tier
    this.tiers.forEach(element => {
      if(element.attribute_value_id == id){
        tier = element
      }
    });
   
    switch (id) {
      case '13':
        this.selectedAP.value.tier = tier.attribute_value_culture
        this.selectedAP.value.price = '25'
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break;
      case '14':
        this.selectedAP.value.tier = tier.attribute_value_culture
        this.selectedAP.value.price = '55'
        this.articleAttributeList = {
          attributeId: tier.attribute_id,
          attributeName: tier.attribute_culture,
          attributeValue: tier.attribute_value_culture,
          attributeValueId: tier.attribute_value_id
        }
        break;
      default:

        break;
    }
  }

  selectPackage(){
    if(this.selectedAP.value.attributeId == null){
      const dialogConfig = new MatDialogConfig();

      this.matDialog.open(BookingAssistancePackageComponent, dialogConfig);
    }
    else if(this.selectedAP.value.attributeId == "14"){
      const dialogConfig = new MatDialogConfig(); 
      let modalDialog = this.matDialog.open(ConfirmDesignTermsComponent, dialogConfig);
      modalDialog.afterClosed().subscribe((result) => 
      {
        if(result == 'success'){
          let orderArticle = {
            id: this.article.id,
            title: this.article.title,
            price: this.selectedAP.value.price,
            attributes: [this.articleAttributeList],
            quantity: 1
          }
          this.orderArticle = orderArticle

          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            article: this.orderArticle,
          }

          this.matDialog.open(BuyAssistancePackageComponent, dialogConfig);
        }
        else{
          this.matDialog.closeAll()
        }
      })
    }
    else{
      let orderArticle = {
          id: this.article.id,
          title: this.article.title,
          price: this.selectedAP.value.price,
          attributes: [this.articleAttributeList],
          quantity: 1
        }
        this.orderArticle = orderArticle

        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          article: this.orderArticle,
        }

        this.matDialog.open(BuyAssistancePackageComponent, dialogConfig);
    }

  }

  async ngOnInit() {
    await this.articleSrv.getArticleById(3).then( async (articles: any) =>{
      articles.forEach( async obj => {
        if(obj.id == 3){
          this.article = obj
        }
      });
      await this.articleSrv.getArticleAttributeValues(this.article.id).then( values =>{
        this.tiers = values;
        //selecting id of first tier
        this.changeId(null);
        this.selectedTier(this.selectedAP.value.attributeId);
      })
    })

  }

}
